












































































































































import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import FilterButton from '../components/common/Button/FilterButton.vue';
import Chart from '../components/DashboardView/ChartGroup/Chart/ChartContainer.vue';
import ChartGroupTemplate from '../components/DashboardView/ChartGroup/ChartGroupTemplate.vue';
import ChartLabelBoxplot from '@/components/DashboardView/ChartGroup/Chart/ChartLabelBoxplot.vue';
import ChartLabelDistHistogram from '@/components/DashboardView/ChartGroup/Chart/ChartLabelDistHistogram.vue';
import ChartLabelSortedClassHistogram from '@/components/DashboardView/ChartGroup/Chart/ChartLabelSortedClassHistogram.vue';
import ChartLabelClassDonut from '@/components/DashboardView/ChartGroup/Chart/ChartLabelClassDonut.vue';
import ChartLabelArrayCountBoxplot from '@/components/DashboardView/ChartGroup/Chart/ChartLabelArrayCountBoxplot.vue';
import ChartLabelSchemaErrorBar from '@/components/DashboardView/ChartGroup/Chart/ChartLabelSchemaErrorBar.vue';
import Button from '../components/common/Button/Button.vue';

export default Vue.extend({
  components: {
    GNB,
    Spinner,
    FilterButton,
    Chart,
    ChartGroupTemplate,
    ChartLabelBoxplot,
    ChartLabelDistHistogram,
    ChartLabelSortedClassHistogram,
    ChartLabelClassDonut,
    ChartLabelArrayCountBoxplot,
    ChartLabelSchemaErrorBar,
    Button,
  },
  data(): {
    isGraphPossibleToDraw: boolean[][];
    isLabelSelected: boolean[];
    isGraphTypeSelected: boolean[];
    labelFilterKeys: { rawKey: string; shownKey: string }[];
  } {
    return {
      isGraphPossibleToDraw: [],
      isLabelSelected: [],
      isGraphTypeSelected: [],
      labelFilterKeys: [],
    };
  },
  async created() {
    // 분석 결과가 store에 없는데 직접 URL로 접근한 경우 저장 후 created 훅 진행

    const parsedURL = this.$route.path.split('/');
    const datasetIdx = parsedURL.indexOf('dataset');
    const labelsetIdx = parsedURL.indexOf('labelset');

    await this.$store.dispatch('getChartAnalysisData', {
      APIURL: `/api/v1/datasets/${parsedURL[datasetIdx + 1]}/analysis/file`,
    });

    if (labelsetIdx != -1) {
      await this.$store.dispatch('getLabelChartAnalysisData', {
        APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
      });
      await this.$store.dispatch('getSchemaChartAnalysisData', {
        APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
      });
    }

    const labelAnalysisResult = this.$store.getters.labelAnalysisResult;
    const schemaAnalysisResult =
      this.$store.getters.schemaAnalysisResult.violationPerProp;

    const isGraphPossibleToDraw: boolean[][] = [];
    this.labelFilterKeys = Object.keys(labelAnalysisResult).map(
      (key: string) => {
        const isGraphPossibleToDrawWithKey: boolean[] = [];
        // 도넛 그래프를 그릴 수 있는지 여부를 체크 [0]
        if (labelAnalysisResult[key].class_counts) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }
        // 수치 그래프를 그릴 수 있는지 여부를 체크 [1]
        if (labelAnalysisResult[key].hist) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }
        // 클래스 그래프를 그릴 수 있는지 여부를 체크 [2]
        if (labelAnalysisResult[key].class_counts) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }
        // 박스 그래프를 그릴 수 있는지 여부를 체크 [3]
        if (labelAnalysisResult[key].boxplot) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }
        // 배열 개수 그래프를 그릴 수 있는지 여부를 체크 [4]
        if (labelAnalysisResult[key].array_count_boxplot) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }
        isGraphPossibleToDraw.push(isGraphPossibleToDrawWithKey);
        // 구문 정확성 오류 통계를 그릴 수 있는지 여부를 체크 [5]
        const keyForSchema = '/' + key.replace(/\./g, '/');
        if (schemaAnalysisResult[keyForSchema]) {
          isGraphPossibleToDrawWithKey.push(true);
        } else {
          isGraphPossibleToDrawWithKey.push(false);
        }

        const splitedKey = key.split('.');
        return {
          rawKey: key,
          shownKey: splitedKey[splitedKey.length - 1],
        };
      },
    );
    this.isGraphPossibleToDraw = isGraphPossibleToDraw;

    this.isLabelSelected = Array(this.isGraphPossibleToDraw.length).fill(true);
    this.isGraphTypeSelected = Array(6).fill(true);
  },
  computed: {
    isSelectAll(): boolean {
      return this.isLabelSelected.every((isSelected: boolean) => !isSelected);
    },
  },
  methods: {
    onClickFilterButton(e: HTMLElement) {
      const clickedButtonIdxOnString: string | undefined = e.dataset?.index;
      if (clickedButtonIdxOnString === undefined) {
        console.error('no data-index on FilterButton in GraphView.vue');
        return;
      }
      const clickedButtonIdx: number = parseInt(clickedButtonIdxOnString);
      if (e.dataset?.type === 'label') {
        /*const nextIsLabelSelected = this.isLabelSelected;
        nextIsLabelSelected[clickedButtonIdx] =
          !nextIsLabelSelected[clickedButtonIdx];
        this.isLabelSelected = nextIsLabelSelected;*/
        this.isLabelSelected.splice(
          clickedButtonIdx,
          1,
          !this.isLabelSelected[clickedButtonIdx],
        );
      } else if (e.dataset?.type === 'graph') {
        /*const nextIsGraphTypeSelected = this.isGraphTypeSelected;
        nextIsGraphTypeSelected[clickedButtonIdx] =
          !nextIsGraphTypeSelected[clickedButtonIdx];
        this.isGraphTypeSelected = nextIsGraphTypeSelected;*/
        this.isGraphTypeSelected.splice(
          clickedButtonIdx,
          1,
          !this.isGraphTypeSelected[clickedButtonIdx],
        );
      }
    },
    toggleAllFilter() {
      // toggle all filter in isLabelSelected
      if (this.isSelectAll) {
        this.isLabelSelected = Array(this.isLabelSelected.length).fill(true);
      } else {
        this.isLabelSelected = Array(this.isLabelSelected.length).fill(false);
      }
    },
  },
});
